import BackgroundImg from 'assets/img/background.png';
import { HeadlineLarge } from 'common/typography/HeadlineLarge';
import { HeadlineMedium } from 'common/typography/HeadlineMedium';
import { useBreakpoints } from 'hooks/use-breakpoints';
import React from 'react';
import { Header } from 'shared/components/header';
import { BackgroundContainer, BackgroundImageStyled, BackgroundOverlay, BackgroundTextWrapper } from './styles';

export const PageBackground: React.FC = () => {
  const { isDesktop } = useBreakpoints();

  return (
    <BackgroundContainer>
      <BackgroundImageStyled src={BackgroundImg} alt="" />
      <Header />

      <BackgroundOverlay>
        <BackgroundTextWrapper>
          {isDesktop ? (
            <HeadlineLarge>Seu Motorola parcelado até 18x sem cartão</HeadlineLarge>
          ) : (
            <HeadlineMedium>Seu Motorola parcelado até 18x sem cartão!</HeadlineMedium>
          )}
        </BackgroundTextWrapper>
      </BackgroundOverlay>
    </BackgroundContainer>
  );
};
